
import {Component, Prop, Vue} from "vue-property-decorator";
import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
import {IFormBuilder} from "@/modules/FormBuilder/interfaces/form-builder.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import {IAccounts} from "@/modules/Profile/interfaces/accounts.interface";
import {accountResource} from "@/modules/Profile/resources/accounts.resource";
import {IBook} from "@/interfaces/book.interface";
import * as emailValidator from "email-validator";
import {bus} from "@/plugins/bus";

  @Component({
    components: {FormBuilderField}
  })
  export default class AccountForm extends Vue {
    @Prop() payload: IAccounts.IPopupPayload;

    $refs: any;
    dataReady = false;
    formModel: any = {
      surName: '',
      firstName: '',
      middleName: '',
      email: '',
      phone: '',
      corpId: null,
      corpName: '',
      id: null,
    };

    get storeState(): IAppState { return this.$store.state; }

    get formFields(): IFormBuilder.IField[] {
      let fields: IFormBuilder.IField[] = [
        { prop: 'id', type: IFormBuilder.FieldType.Input, label: 'Код', disabled: true, hidden: this.payload.createMode, },
        { prop: 'corpName', type: IFormBuilder.FieldType.Input, label: 'Корпорация', disabled: true, },
        { prop: 'firstName', type: IFormBuilder.FieldType.Input, label: 'Имя', required: true, },
        { prop: 'surName', type: IFormBuilder.FieldType.Input, label: 'Фамилия', },
        { prop: 'middleName', type: IFormBuilder.FieldType.Input, label: 'Отчество', },
        { prop: 'email', type: IFormBuilder.FieldType.Input, label: 'E-mail', required: true, },
        { prop: 'phone', type: IFormBuilder.FieldType.Phone, label: 'Телефон', placeholder: '+7 (', required: true, },
      ];
      return fields
    }

    get formRules() {
      return {
        firstName: [{required: true, message: ' ', trigger: 'blur'}],
        phone: [{
          validator: (rule, value, callback) => this.formModel.email || !!value ? callback() : callback(new Error(' ')),
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        email: [{
          validator: (rule, value, callback) => this.formModel.phone || emailValidator.validate(value) ? callback() : callback(new Error(' ')),
          message: ' ',
          trigger: 'blur'
        }]
      };
    }

    async created() {
      let personFields = ['id', 'surName', 'firstName', 'middleName', 'email', 'phone',];
      personFields.forEach(field => {
        this.formModel[field] = this.payload.createMode ? '' : this.payload.person[field];
      });
      this.formModel = {
        ...this.formModel,
        corpId: this.payload.corpId,
        corpName: this.payload.corpName,
      };
      this.dataReady = true;
    }

    async saveChanges() {
      this.$refs.accountForm.validate(async (valid) => {
        if (!valid) return false;

        let payload: IAccounts.ICreateAccountPayload = {
          ...this.formModel,
          makePersonFromCorps: true,
        };
        if (!this.payload.createMode) payload.id = this.payload.person.id;

        let requestData = this.payload.createMode
          ? await accountResource.createAccount(payload)
          : await accountResource.updateAccount(payload as IAccounts.IUpdateAccountPayload);
        if (requestData.success) {
          this.$notify({
            title: 'Успешно',
            message: this.payload.createMode ? requestData.response.message : 'Данные аккаунта обновлены',
            type: 'success'
          });

          let eventName = this.payload.createMode ? IAccounts.Events.AccountTableCreateItem : IAccounts.Events.AccountTableUpdateItem;
          bus.$emit(eventName, requestData.response.persons[0]);
          this.$emit('onClose');
        }
        else {
          this.$notify.error({
            title: 'Ошибка',
            message: requestData.error.message,
          });
        }
      });
    }
  }
